import { render, staticRenderFns } from "./CommonInfo.vue?vue&type=template&id=02a1a047&scoped=true&"
import script from "./CommonInfo.vue?vue&type=script&lang=js&"
export * from "./CommonInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a1a047",
  null
  
)

export default component.exports